export enum StepExecStatus {
    NOT_EXECUTED="0",
    AS_EXPECTED="10",
    NOT_AS_EXPECTED_FINDING_A="20",
    NOT_AS_EXPECTED_FINDING_B="30",
    NOT_AS_EXPECTED_FINDING_C="40",
    NOT_AS_EXPECTED_COMMENTS="50"
}